import axios from '../axios-init';

// 仓库对神医Category设置的特殊价格
export const getDoctorUserList = params => {
    return axios.post(`/custom_box_size_config/getDoctorUserList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCustomBoxSizeList = params => {
    return axios.post(`/custom_box_size_config/getBoxSizeList`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const getCustomBoxSizeById = params => {
    return axios.post(`/custom_box_size_config/getBoxSizeById`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const editCustomBoxSizeConfigs = params => {
    return axios.post(`/custom_box_size_config/addOrEditCustomBoxSizeConfigs`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};

export const deleteCustomBoxSizeConfigs = params => {
    return axios.post(`/custom_box_size_config/restoreCustomBoxSizeConfigs`, params).then(res => {
        return res.data;
    }).catch(
        error => error);
};



// WEBPACK FOOTER //
// ./src/api/customBoxSizeConfigService.js